exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree {\n  padding: 5px;\n}\n.select-component.active {\n  color: #3ba776;\n}\n.select-component.active .vue-ui-icon {\n  animation: pulse 2s infinite linear;\n}\n", ""]);

// exports
